import axios from "axios";
import { useState } from "react";
import { FaReply } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Layout from "../../components/layout/Layout";
import { formatDate } from "../../helpers/DateConversion";

export default function ViewSupport() {
  const location = useLocation();
  const data = location.state.data;

  const [reply, setReply] = useState("");
  const [status, setStatus] = useState('');

  const supportOptions = {
    0: "Order Issues",
    1: "Shipping & Delivery",
    2: "Returns & Refunds",
    3: "Payment Issues",
    4: "Contact Customer Service",
    5: "FAQs"
  };

  const navigate = useNavigate("");

  const replyToSupport = async (e) => {
    e.preventDefault();

    try {
      const headers = {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem("sansadToken")}`,
      };

      if (!status.trim()) {
        toast.error("Please select status.");
        return;
      }
      if (!reply.trim()) {
        toast.error("Please enter reply.");
        return;
      }

      const formdata = new FormData();
      formdata.append("reply", reply);
      formdata.append("supportId", data?._id);
      formdata.append("status", status);

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/support/make-resolve`,
        formdata,
        { headers }
      );

      if (response.data.statusCode === 200) {
        toast.success(response?.data?.message);
        setTimeout(() => navigate("/admin-panel/supports/1"), 1500);
      } else {
        toast.error(response?.data?.message || "Something went wrong.");
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to update support. Please try again.");
    }
    setReply("");
  };

  return (
    <div>
      <Layout>
        <ToastContainer />
        <div className="bg-white md:p-10 p-3 rounded-xl shadow-md mt-8">
          <div className="flex justify-between items-center">
            <h2 className="text-xl font-medium">View Support</h2>
          </div>
          <div className="mt-10">
            <div className="flex my-6">
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Id</h6>
                <p className="mt-1">{data._id}</p>
              </div>
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Support Type</h6>
                <p className="mt-1">{supportOptions[data.supportType]}</p>
              </div>
            </div>
            <hr />

            <div className="flex my-6">
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Full Name</h6>
                <p className="mt-1">{data?.userId?.firstName}</p>
              </div>
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Email</h6>
                <p className="mt-1">{data?.userId?.email}</p>
              </div>
            </div>
            <hr />
            <div className="flex my-6">
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Status</h6>
                <p className="mt-1">{data.status}</p>
              </div>
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Created At</h6>
                <p className="mt-1">{formatDate(data.createdAt)}</p>
              </div>
            </div>

            <div className="flex my-6">
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Description</h6>
                <p className="mt-1">{data.description}</p>
              </div>

              <div className="w-1/2">
                <h6 className="text-sm font-medium">Admin Reply</h6>
                <ul className="mt-1 space-y-2">
                  {Array.isArray(data?.reply) && data.reply.length > 0 ? (
                    <ul className="space-y-2">
                      {data.reply.map((r) => {
                        const dateObj = new Date(r.date);
                        const formattedDate = isNaN(dateObj.getTime())
                          ? "No replies yet"
                          : dateObj.toLocaleString("en-IN", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                          });

                        return (
                          <li key={r._id} className="border-b pb-1">
                            <p className="text-gray-800">{r.message}</p>
                            <span className="text-xs text-gray-500">{formattedDate}</span>
                          </li>
                        );
                      })}
                    </ul>
                  ) : (
                    <p className="text-gray-500 text-sm">No replies yet.</p>
                  )}

                </ul>
              </div>


            </div>



            <hr />
          </div>
          {
            data.status !== "resolved" && data.status !== "Refund Completed" && <div className="mt-10">
              <button
                type="button"
                className="btn flex gap-3 items-center border"
                data-toggle="modal"
                data-target="#staticBackdrop"
              >
                <span>
                  <FaReply size={18} />
                </span>
                <span>Reply</span>
              </button>
            </div>
          }

        </div>
        {/* Modal */}
        <div
          className="modal fade"
          id="staticBackdrop"
          data-backdrop="static"
          data-keyboard="false"
          tabIndex={-1}
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="staticBackdropLabel">
                  Reply
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>

              <div className="modal-body">
                <h2 className="text-lg font-semibold mb-4">Update Support Status</h2>

                <label htmlFor="status" className="block text-sm font-medium mb-1">
                  Status
                </label>
                <select
                  name="status"
                  id="status"
                  className="border h-[40px] px-3 w-full rounded-md !outline-none text-sm mb-4"
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                  required
                >
                  <option value="">Select Status</option>
                  <option value="resolved">Resolved</option>
                  <option value="unresolved">Unresolved</option>
                  <option value="Refund Completed">Refund Completed</option>
                </select>

                <label htmlFor="reply" className="block text-sm font-medium mb-1">
                  Message
                </label>
                <textarea
                  name="reply"
                  id="reply"
                  className="h-[100px] resize-none border !outline-none p-2 w-full rounded-md placeholder:text-sm text-sm"
                  placeholder="Write your message here..."
                  value={reply}
                  onChange={(e) => setReply(e.target.value)}
                ></textarea>
              </div>


              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-dark"
                  onClick={replyToSupport}
                  data-dismiss="modal"
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </div>
  );
}


